import { getContrast, parseToRgba, getLuminance, toHex, transparentize } from "color2k";
import { createThemedCssVarDefinitions } from "@creditornot/cb-utils";
const bg = "var(--cb-color-bg)";
const bgSurface = "var(--cb-color-bg-surface)";
const bgSurfaceHovered = "var(--cb-color-bg-surface-hovered)";
const bgSurfacePressed = "var(--cb-color-bg-surface-pressed)";
const bgSurfaceSelected = "var(--cb-color-bg-surface-selected)";
const bgSurfaceDisabled = "var(--cb-color-bg-surface-disabled)";
const bgSurfaceSecondary = "var(--cb-color-bg-surface-secondary)";
const bgSurfaceSecondaryHovered = "var(--cb-color-bg-surface-secondary-hovered)";
const bgSurfaceSecondaryPressed = "var(--cb-color-bg-surface-secondary-pressed)";
const bgSurfaceSecondarySelected = "var(--cb-color-bg-surface-secondary-selected)";
const bgSurfaceSecondaryDisabled = "var(--cb-color-bg-surface-secondary-disabled)";
const bgSurfaceTertiary = "var(--cb-color-bg-surface-tertiary)";
const bgSurfaceTertiaryHovered = "var(--cb-color-bg-surface-tertiary-hovered)";
const bgSurfaceTertiaryPressed = "var(--cb-color-bg-surface-tertiary-pressed)";
const bgSurfaceTertiarySelected = "var(--cb-color-bg-surface-tertiary-selected)";
const bgSurfaceTertiaryDisabled = "var(--cb-color-bg-surface-tertiary-disabled)";
const bgFill = "var(--cb-color-bg-fill)";
const bgFillHovered = "var(--cb-color-bg-fill-hovered)";
const bgFillPressed = "var(--cb-color-bg-fill-pressed)";
const bgFillSelected = "var(--cb-color-bg-fill-selected)";
const bgFillDisabled = "var(--cb-color-bg-fill-disabled)";
const text = "var(--cb-color-text)";
const textHovered = "var(--cb-color-text-hovered)";
const textPressed = "var(--cb-color-text-pressed)";
const textSelected = "var(--cb-color-text-selected)";
const textDisabled = "var(--cb-color-text-disabled)";
const textSubdued = "var(--cb-color-text-subdued)";
const textOnBgFill = "var(--cb-color-text-on-bg-fill)";
const textOnBgFillHovered = "var(--cb-color-text-on-bg-fill-hovered)";
const textOnBgFillPressed = "var(--cb-color-text-on-bg-fill-pressed)";
const textOnBgFillSelected = "var(--cb-color-text-on-bg-fill-selected)";
const textOnBgFillDisabled = "var(--cb-color-text-on-bg-fill-disabled)";
const border = "var(--cb-color-border)";
const borderHovered = "var(--cb-color-border-hovered)";
const borderPressed = "var(--cb-color-border-pressed)";
const borderSelected = "var(--cb-color-border-selected)";
const borderDisabled = "var(--cb-color-border-disabled)";
const borderSubdued = "var(--cb-color-border-subdued)";
const borderNegative = "var(--cb-color-border-negative)";
const outlineFocused = "var(--cb-color-outline-focused)";
const bgSurfaceBrand = "var(--cb-color-bg-surface-brand)";
const bgSurfaceBrandHovered = "var(--cb-color-bg-surface-brand-hovered)";
const bgSurfaceBrandPressed = "var(--cb-color-bg-surface-brand-pressed)";
const bgSurfaceBrandSelected = "var(--cb-color-bg-surface-brand-selected)";
const bgSurfaceBrandDisabled = "var(--cb-color-bg-surface-brand-disabled)";
const bgFillBrand = "var(--cb-color-bg-fill-brand)";
const bgFillBrandHovered = "var(--cb-color-bg-fill-brand-hovered)";
const bgFillBrandPressed = "var(--cb-color-bg-fill-brand-pressed)";
const bgFillBrandSelected = "var(--cb-color-bg-fill-brand-selected)";
const bgFillBrandDisabled = "var(--cb-color-bg-fill-brand-disabled)";
const textBrand = "var(--cb-color-text-brand)";
const textBrandHovered = "var(--cb-color-text-brand-hovered)";
const textBrandPressed = "var(--cb-color-text-brand-pressed)";
const textBrandSelected = "var(--cb-color-text-brand-selected)";
const textBrandDisabled = "var(--cb-color-text-brand-disabled)";
const textOnBgFillBrand = "var(--cb-color-text-on-bg-fill-brand)";
const textOnBgFillBrandHovered = "var(--cb-color-text-on-bg-fill-brand-hovered)";
const textOnBgFillBrandPressed = "var(--cb-color-text-on-bg-fill-brand-pressed)";
const textOnBgFillBrandSelected = "var(--cb-color-text-on-bg-fill-brand-selected)";
const textOnBgFillBrandDisabled = "var(--cb-color-text-on-bg-fill-brand-disabled)";
const bgSurfaceNegative = "var(--cb-color-bg-surface-negative)";
const bgSurfaceNegativeHovered = "var(--cb-color-bg-surface-negative-hovered)";
const bgSurfaceNegativePressed = "var(--cb-color-bg-surface-negative-pressed)";
const bgSurfaceNegativeSelected = "var(--cb-color-bg-surface-negative-selected)";
const bgSurfaceNegativeDisabled = "var(--cb-color-bg-surface-negative-disabled)";
const bgFillNegative = "var(--cb-color-bg-fill-negative)";
const bgFillNegativeHovered = "var(--cb-color-bg-fill-negative-hovered)";
const bgFillNegativePressed = "var(--cb-color-bg-fill-negative-pressed)";
const bgFillNegativeSelected = "var(--cb-color-bg-fill-negative-selected)";
const bgFillNegativeDisabled = "var(--cb-color-bg-fill-negative-disabled)";
const textNegative = "var(--cb-color-text-negative)";
const textNegativeHovered = "var(--cb-color-text-negative-hovered)";
const textNegativePressed = "var(--cb-color-text-negative-pressed)";
const textNegativeSelected = "var(--cb-color-text-negative-selected)";
const textNegativeDisabled = "var(--cb-color-text-negative-disabled)";
const textOnBgFillNegative = "var(--cb-color-text-on-bg-fill-negative)";
const textOnBgFillNegativeHovered = "var(--cb-color-text-on-bg-fill-negative-hovered)";
const textOnBgFillNegativePressed = "var(--cb-color-text-on-bg-fill-negative-pressed)";
const textOnBgFillNegativeSelected = "var(--cb-color-text-on-bg-fill-negative-selected)";
const textOnBgFillNegativeDisabled = "var(--cb-color-text-on-bg-fill-negative-disabled)";
const bgSurfaceWarning = "var(--cb-color-bg-surface-warning)";
const bgSurfaceWarningHovered = "var(--cb-color-bg-surface-warning-hovered)";
const bgSurfaceWarningPressed = "var(--cb-color-bg-surface-warning-pressed)";
const bgSurfaceWarningSelected = "var(--cb-color-bg-surface-warning-selected)";
const bgSurfaceWarningDisabled = "var(--cb-color-bg-surface-warning-disabled)";
const bgFillWarning = "var(--cb-color-bg-fill-warning)";
const bgFillWarningHovered = "var(--cb-color-bg-fill-warning-hovered)";
const bgFillWarningPressed = "var(--cb-color-bg-fill-warning-pressed)";
const bgFillWarningSelected = "var(--cb-color-bg-fill-warning-selected)";
const bgFillWarningDisabled = "var(--cb-color-bg-fill-warning-disabled)";
const textWarning = "var(--cb-color-text-warning)";
const textWarningHovered = "var(--cb-color-text-warning-hovered)";
const textWarningPressed = "var(--cb-color-text-warning-pressed)";
const textWarningSelected = "var(--cb-color-text-warning-selected)";
const textWarningDisabled = "var(--cb-color-text-warning-disabled)";
const textOnBgFillWarning = "var(--cb-color-text-on-bg-fill-warning)";
const textOnBgFillWarningHovered = "var(--cb-color-text-on-bg-fill-warning-hovered)";
const textOnBgFillWarningPressed = "var(--cb-color-text-on-bg-fill-warning-pressed)";
const textOnBgFillWarningSelected = "var(--cb-color-text-on-bg-fill-warning-selected)";
const textOnBgFillWarningDisabled = "var(--cb-color-text-on-bg-fill-warning-disabled)";
const bgSurfacePositive = "var(--cb-color-bg-surface-positive)";
const bgSurfacePositiveHovered = "var(--cb-color-bg-surface-positive-hovered)";
const bgSurfacePositivePressed = "var(--cb-color-bg-surface-positive-pressed)";
const bgSurfacePositiveSelected = "var(--cb-color-bg-surface-positive-selected)";
const bgSurfacePositiveDisabled = "var(--cb-color-bg-surface-positive-disabled)";
const bgFillPositive = "var(--cb-color-bg-fill-positive)";
const bgFillPositiveHovered = "var(--cb-color-bg-fill-positive-hovered)";
const bgFillPositivePressed = "var(--cb-color-bg-fill-positive-pressed)";
const bgFillPositiveSelected = "var(--cb-color-bg-fill-positive-selected)";
const bgFillPositiveDisabled = "var(--cb-color-bg-fill-positive-disabled)";
const textPositive = "var(--cb-color-text-positive)";
const textPositiveHovered = "var(--cb-color-text-positive-hovered)";
const textPositivePressed = "var(--cb-color-text-positive-pressed)";
const textPositiveSelected = "var(--cb-color-text-positive-selected)";
const textPositiveDisabled = "var(--cb-color-text-positive-disabled)";
const textOnBgFillPositive = "var(--cb-color-text-on-bg-fill-positive)";
const textOnBgFillPositiveHovered = "var(--cb-color-text-on-bg-fill-positive-hovered)";
const textOnBgFillPositivePressed = "var(--cb-color-text-on-bg-fill-positive-pressed)";
const textOnBgFillPositiveSelected = "var(--cb-color-text-on-bg-fill-positive-selected)";
const textOnBgFillPositiveDisabled = "var(--cb-color-text-on-bg-fill-positive-disabled)";
const bgSurfaceInverse = "var(--cb-color-bg-surface-inverse)";
const bgSurfaceInverseHovered = "var(--cb-color-bg-surface-inverse-hovered)";
const bgSurfaceInversePressed = "var(--cb-color-bg-surface-inverse-pressed)";
const bgSurfaceInverseSelected = "var(--cb-color-bg-surface-inverse-selected)";
const bgSurfaceInverseDisabled = "var(--cb-color-bg-surface-inverse-disabled)";
const bgFillInverse = "var(--cb-color-bg-fill-inverse)";
const bgFillInverseHovered = "var(--cb-color-bg-fill-inverse-hovered)";
const bgFillInversePressed = "var(--cb-color-bg-fill-inverse-pressed)";
const bgFillInverseSelected = "var(--cb-color-bg-fill-inverse-selected)";
const bgFillInverseDisabled = "var(--cb-color-bg-fill-inverse-disabled)";
const textInverse = "var(--cb-color-text-inverse)";
const textInverseHovered = "var(--cb-color-text-inverse-hovered)";
const textInversePressed = "var(--cb-color-text-inverse-pressed)";
const textInverseSelected = "var(--cb-color-text-inverse-selected)";
const textInverseDisabled = "var(--cb-color-text-inverse-disabled)";
const textOnBgFillInverse = "var(--cb-color-text-on-bg-fill-inverse)";
const textOnBgFillInverseHovered = "var(--cb-color-text-on-bg-fill-inverse-hovered)";
const textOnBgFillInversePressed = "var(--cb-color-text-on-bg-fill-inverse-pressed)";
const textOnBgFillInverseSelected = "var(--cb-color-text-on-bg-fill-inverse-selected)";
const textOnBgFillInverseDisabled = "var(--cb-color-text-on-bg-fill-inverse-disabled)";
const bgSurfaceTransparent = "var(--cb-color-bg-surface-transparent)";
const bgSurfaceTransparentHovered = "var(--cb-color-bg-surface-transparent-hovered)";
const bgSurfaceTransparentPressed = "var(--cb-color-bg-surface-transparent-pressed)";
const bgSurfaceTransparentSelected = "var(--cb-color-bg-surface-transparent-selected)";
const bgSurfaceTransparentDisabled = "var(--cb-color-bg-surface-transparent-disabled)";
const bgFillTransparent = "var(--cb-color-bg-fill-transparent)";
const bgFillTransparentHovered = "var(--cb-color-bg-fill-transparent-hovered)";
const bgFillTransparentPressed = "var(--cb-color-bg-fill-transparent-pressed)";
const bgFillTransparentSelected = "var(--cb-color-bg-fill-transparent-selected)";
const bgFillTransparentDisabled = "var(--cb-color-bg-fill-transparent-disabled)";
const textTransparent = "var(--cb-color-text-transparent)";
const textTransparentHovered = "var(--cb-color-text-transparent-hovered)";
const textTransparentPressed = "var(--cb-color-text-transparent-pressed)";
const textTransparentSelected = "var(--cb-color-text-transparent-selected)";
const textTransparentDisabled = "var(--cb-color-text-transparent-disabled)";
const textOnBgFillTransparent = "var(--cb-color-text-on-bg-fill-transparent)";
const textOnBgFillTransparentHovered = "var(--cb-color-text-on-bg-fill-transparent-hovered)";
const textOnBgFillTransparentPressed = "var(--cb-color-text-on-bg-fill-transparent-pressed)";
const textOnBgFillTransparentSelected = "var(--cb-color-text-on-bg-fill-transparent-selected)";
const textOnBgFillTransparentDisabled = "var(--cb-color-text-on-bg-fill-transparent-disabled)";
const bgOverlay = "var(--cb-color-bg-overlay)";
const fixedWhite = "var(--cb-color-fixed-white)";
const fixedBlack = "var(--cb-color-fixed-black)";
const shadow$1 = "var(--cb-color-shadow)";
const color = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bg,
  bgFill,
  bgFillBrand,
  bgFillBrandDisabled,
  bgFillBrandHovered,
  bgFillBrandPressed,
  bgFillBrandSelected,
  bgFillDisabled,
  bgFillHovered,
  bgFillInverse,
  bgFillInverseDisabled,
  bgFillInverseHovered,
  bgFillInversePressed,
  bgFillInverseSelected,
  bgFillNegative,
  bgFillNegativeDisabled,
  bgFillNegativeHovered,
  bgFillNegativePressed,
  bgFillNegativeSelected,
  bgFillPositive,
  bgFillPositiveDisabled,
  bgFillPositiveHovered,
  bgFillPositivePressed,
  bgFillPositiveSelected,
  bgFillPressed,
  bgFillSelected,
  bgFillTransparent,
  bgFillTransparentDisabled,
  bgFillTransparentHovered,
  bgFillTransparentPressed,
  bgFillTransparentSelected,
  bgFillWarning,
  bgFillWarningDisabled,
  bgFillWarningHovered,
  bgFillWarningPressed,
  bgFillWarningSelected,
  bgOverlay,
  bgSurface,
  bgSurfaceBrand,
  bgSurfaceBrandDisabled,
  bgSurfaceBrandHovered,
  bgSurfaceBrandPressed,
  bgSurfaceBrandSelected,
  bgSurfaceDisabled,
  bgSurfaceHovered,
  bgSurfaceInverse,
  bgSurfaceInverseDisabled,
  bgSurfaceInverseHovered,
  bgSurfaceInversePressed,
  bgSurfaceInverseSelected,
  bgSurfaceNegative,
  bgSurfaceNegativeDisabled,
  bgSurfaceNegativeHovered,
  bgSurfaceNegativePressed,
  bgSurfaceNegativeSelected,
  bgSurfacePositive,
  bgSurfacePositiveDisabled,
  bgSurfacePositiveHovered,
  bgSurfacePositivePressed,
  bgSurfacePositiveSelected,
  bgSurfacePressed,
  bgSurfaceSecondary,
  bgSurfaceSecondaryDisabled,
  bgSurfaceSecondaryHovered,
  bgSurfaceSecondaryPressed,
  bgSurfaceSecondarySelected,
  bgSurfaceSelected,
  bgSurfaceTertiary,
  bgSurfaceTertiaryDisabled,
  bgSurfaceTertiaryHovered,
  bgSurfaceTertiaryPressed,
  bgSurfaceTertiarySelected,
  bgSurfaceTransparent,
  bgSurfaceTransparentDisabled,
  bgSurfaceTransparentHovered,
  bgSurfaceTransparentPressed,
  bgSurfaceTransparentSelected,
  bgSurfaceWarning,
  bgSurfaceWarningDisabled,
  bgSurfaceWarningHovered,
  bgSurfaceWarningPressed,
  bgSurfaceWarningSelected,
  border,
  borderDisabled,
  borderHovered,
  borderNegative,
  borderPressed,
  borderSelected,
  borderSubdued,
  fixedBlack,
  fixedWhite,
  outlineFocused,
  shadow: shadow$1,
  text,
  textBrand,
  textBrandDisabled,
  textBrandHovered,
  textBrandPressed,
  textBrandSelected,
  textDisabled,
  textHovered,
  textInverse,
  textInverseDisabled,
  textInverseHovered,
  textInversePressed,
  textInverseSelected,
  textNegative,
  textNegativeDisabled,
  textNegativeHovered,
  textNegativePressed,
  textNegativeSelected,
  textOnBgFill,
  textOnBgFillBrand,
  textOnBgFillBrandDisabled,
  textOnBgFillBrandHovered,
  textOnBgFillBrandPressed,
  textOnBgFillBrandSelected,
  textOnBgFillDisabled,
  textOnBgFillHovered,
  textOnBgFillInverse,
  textOnBgFillInverseDisabled,
  textOnBgFillInverseHovered,
  textOnBgFillInversePressed,
  textOnBgFillInverseSelected,
  textOnBgFillNegative,
  textOnBgFillNegativeDisabled,
  textOnBgFillNegativeHovered,
  textOnBgFillNegativePressed,
  textOnBgFillNegativeSelected,
  textOnBgFillPositive,
  textOnBgFillPositiveDisabled,
  textOnBgFillPositiveHovered,
  textOnBgFillPositivePressed,
  textOnBgFillPositiveSelected,
  textOnBgFillPressed,
  textOnBgFillSelected,
  textOnBgFillTransparent,
  textOnBgFillTransparentDisabled,
  textOnBgFillTransparentHovered,
  textOnBgFillTransparentPressed,
  textOnBgFillTransparentSelected,
  textOnBgFillWarning,
  textOnBgFillWarningDisabled,
  textOnBgFillWarningHovered,
  textOnBgFillWarningPressed,
  textOnBgFillWarningSelected,
  textPositive,
  textPositiveDisabled,
  textPositiveHovered,
  textPositivePressed,
  textPositiveSelected,
  textPressed,
  textSelected,
  textSubdued,
  textTransparent,
  textTransparentDisabled,
  textTransparentHovered,
  textTransparentPressed,
  textTransparentSelected,
  textWarning,
  textWarningDisabled,
  textWarningHovered,
  textWarningPressed,
  textWarningSelected
}, Symbol.toStringTag, { value: "Module" }));
const spaceNarrowXsmall = "var(--cb-space-narrow-xsmall)";
const spaceNarrowSmall = "var(--cb-space-narrow-small)";
const spaceNarrowMedium = "var(--cb-space-narrow-medium)";
const spaceRegularMedium = "var(--cb-space-regular-medium)";
const spaceRegularLarge = "var(--cb-space-regular-large)";
const spaceRegularXlarge = "var(--cb-space-regular-xlarge)";
const spaceRegularXxlarge = "var(--cb-space-regular-xxlarge)";
const spaceRegularXxxlarge = "var(--cb-space-regular-xxxlarge)";
const spaceBroadMedium = "var(--cb-space-broad-medium)";
const spaceBroadLarge = "var(--cb-space-broad-large)";
const spaceBroadXlarge = "var(--cb-space-broad-xlarge)";
const spaceBroadXxlarge = "var(--cb-space-broad-xxlarge)";
const spaceBroadXxxlarge = "var(--cb-space-broad-xxxlarge)";
const spaceWideMedium = "var(--cb-space-wide-medium)";
const spaceWideLarge = "var(--cb-space-wide-large)";
const spaceWideXlarge = "var(--cb-space-wide-xlarge)";
const spaceWideXxlarge = "var(--cb-space-wide-xxlarge)";
const spaceWideXxxlarge = "var(--cb-space-wide-xxxlarge)";
const cornerRadiusNone = "var(--cb-corner-radius-none)";
const cornerRadiusSmall = "var(--cb-corner-radius-small)";
const cornerRadiusMedium = "var(--cb-corner-radius-medium)";
const cornerRadiusLarge = "var(--cb-corner-radius-large)";
const cornerRadiusXlarge = "var(--cb-corner-radius-xlarge)";
const cornerRadiusMax = "var(--cb-corner-radius-max)";
const borderWidthThickLarge = "var(--cb-border-width-thick-large)";
const borderWidthThickMedium = "var(--cb-border-width-thick-medium)";
const borderWidthRegularLarge = "var(--cb-border-width-regular-large)";
const borderWidthRegularMedium = "var(--cb-border-width-regular-medium)";
const borderWidthThin = "var(--cb-border-width-thin)";
const dimension = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  borderWidthRegularLarge,
  borderWidthRegularMedium,
  borderWidthThickLarge,
  borderWidthThickMedium,
  borderWidthThin,
  cornerRadiusLarge,
  cornerRadiusMax,
  cornerRadiusMedium,
  cornerRadiusNone,
  cornerRadiusSmall,
  cornerRadiusXlarge,
  spaceBroadLarge,
  spaceBroadMedium,
  spaceBroadXlarge,
  spaceBroadXxlarge,
  spaceBroadXxxlarge,
  spaceNarrowMedium,
  spaceNarrowSmall,
  spaceNarrowXsmall,
  spaceRegularLarge,
  spaceRegularMedium,
  spaceRegularXlarge,
  spaceRegularXxlarge,
  spaceRegularXxxlarge,
  spaceWideLarge,
  spaceWideMedium,
  spaceWideXlarge,
  spaceWideXxlarge,
  spaceWideXxxlarge
}, Symbol.toStringTag, { value: "Module" }));
const xsmall = "var(--cb-shadow-xsmall)";
const small = "var(--cb-shadow-small)";
const medium = "var(--cb-shadow-medium)";
const large = "var(--cb-shadow-large)";
const shadow = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  large,
  medium,
  small,
  xsmall
}, Symbol.toStringTag, { value: "Module" }));
const setLuminance = (color2, targetLum) => {
  const [r, g, b] = parseToRgba(color2);
  const currentLum = getLuminance(color2);
  const scale = Math.sqrt(targetLum / currentLum);
  const adjust = (c) => Math.min(255, Math.max(0, Math.round(c * scale)));
  return toHex(`rgb(${adjust(r)}, ${adjust(g)}, ${adjust(b)})`);
};
const adjustLuminanceForContrast = (color1, color2, targetRatio = 4.5) => {
  if (getContrast(color1, color2) >= targetRatio) return color2;
  if (parseToRgba(color1)[3] !== 1 || parseToRgba(color2)[3] !== 1) {
    throw new Error("adjustLuminanceForContrast: provided colors must be opaque");
  }
  const lum1 = getLuminance(color1);
  const targetLum = (lum1 + 0.05) / targetRatio - 0.05;
  return setLuminance(color2, targetLum);
};
function blendColorWithBackground(background, overlay) {
  const bgRgba = parseToRgba(toHex(background));
  if (bgRgba[3] !== 1) {
    throw new Error("blendColorWithBackground: background color must be opaque");
  }
  const overlayRgba = parseToRgba(toHex(overlay));
  const alpha = overlayRgba[3];
  const r = Math.round((1 - alpha) * bgRgba[0] + alpha * overlayRgba[0]);
  const g = Math.round((1 - alpha) * bgRgba[1] + alpha * overlayRgba[1]);
  const b = Math.round((1 - alpha) * bgRgba[2] + alpha * overlayRgba[2]);
  return toHex(`rgb(${r}, ${g}, ${b})`);
}
function readThemedValue(value, themeMode, elevated) {
  if (typeof value === "string") return value;
  if (themeMode === "dark" && typeof value.dark === "object") {
    return elevated ? value.dark.elevated : value.dark.default;
  }
  if (themeMode === "dark" && typeof value.dark === "string") {
    return value.dark;
  }
  if (themeMode === "lightHighContrast") {
    return value.lightHighContrast ?? value.light;
  }
  if (themeMode === "light") {
    return value.light;
  }
  throw new Error(`Invalid theme value: ${JSON.stringify(value)}`);
}
const createModifier = (modifier) => (value) => {
  const lightModifier = typeof modifier === "function" ? modifier : modifier.light;
  const lightHighContrastModifier = typeof modifier === "function" ? modifier : modifier.lightHighContrast;
  const darkModifier = typeof modifier === "function" ? modifier : modifier.dark;
  const light = lightModifier(readThemedValue(value, "light"));
  const lightHighContrast = lightHighContrastModifier ? lightHighContrastModifier(readThemedValue(value, "lightHighContrast")) : void 0;
  const dark = darkModifier(readThemedValue(value, "dark"));
  const darkElevated = typeof value === "object" && typeof value.dark === "object" ? darkModifier(value.dark.elevated) : void 0;
  return {
    light,
    lightHighContrast: lightHighContrast !== void 0 && lightHighContrast !== light ? lightHighContrast : void 0,
    dark: darkElevated ? {
      default: dark,
      elevated: darkElevated
    } : dark
  };
};
const pipeModifiers = (...modifiers2) => (value) => modifiers2.reduce((acc, modifier) => modifier(acc), value);
const trimResult = (result) => {
  const trimmedResult = {
    ...result
  };
  if (trimmedResult.light === trimmedResult.lightHighContrast || trimmedResult.lightHighContrast === void 0) {
    delete trimmedResult.lightHighContrast;
  }
  if (typeof trimmedResult.dark === "object" && trimmedResult.dark.default === trimmedResult.dark.elevated) {
    trimmedResult.dark = trimmedResult.dark.default;
  }
  return trimmedResult;
};
const modifiers = {
  alpha: (alpha) => (value) => {
    const light = transparentize(readThemedValue(value, "light"), 1 - alpha.light);
    const lightHighContrast = transparentize(readThemedValue(value, "lightHighContrast"), 1 - alpha.light);
    const dark = transparentize(readThemedValue(value, "dark"), 1 - alpha.dark);
    const darkElevated = typeof value === "object" && typeof value.dark === "object" ? transparentize(readThemedValue(value, "dark", true), 1 - alpha.dark) : void 0;
    return trimResult({
      light,
      lightHighContrast,
      dark: darkElevated ? {
        default: dark,
        elevated: darkElevated
      } : dark
    });
  },
  solidify: (value) => {
    const light = blendColorWithBackground("#ffffff", readThemedValue(value, "light"));
    const lightHighContrast = blendColorWithBackground("#ffffff", readThemedValue(value, "lightHighContrast"));
    const dark = blendColorWithBackground("#000", readThemedValue(value, "dark"));
    const darkElevated = typeof value === "object" && typeof value.dark === "object" ? blendColorWithBackground("#242424", readThemedValue(value, "dark", true)) : void 0;
    return trimResult({
      light,
      lightHighContrast,
      dark: darkElevated ? {
        default: dark,
        elevated: darkElevated
      } : dark
    });
  },
  elevateOnDarkMode: (value) => ({
    ...typeof value === "object" && value,
    light: readThemedValue(value, "light"),
    dark: {
      default: readThemedValue(value, "dark"),
      elevated: blendColorWithBackground("#242424", readThemedValue(value, "dark", true))
    }
  }),
  toHex: (value) => createModifier(toHex)(value)
};
const generateThemeOverride = ({
  brandColor
}) => {
  if (parseToRgba(brandColor)[3] < 1) throw new Error("Primary color must be opaque.");
  const bgFillBrand2 = {
    light: brandColor,
    lightHighContrast: adjustLuminanceForContrast("#ffffff", brandColor, 4.5),
    dark: brandColor
  };
  const bgSurfaceBrand2 = pipeModifiers(modifiers.alpha({
    light: 0.08,
    dark: 0.16
  }), modifiers.elevateOnDarkMode, modifiers.solidify)(brandColor);
  const textBrand2 = {
    light: brandColor,
    dark: brandColor,
    lightHighContrast: adjustLuminanceForContrast(readThemedValue(bgSurfaceBrand2, "lightHighContrast"), brandColor, 4.5)
  };
  const textOnBgFillBrand2 = {
    light: "#ffffff",
    // flip text color if contrast gets too low, even if it's not a high contrast mode
    dark: getContrast(brandColor, "#202125") >= 2.5 ? "#202125" : "#ffffff"
  };
  const varMap = {
    // brand fill
    bgFillBrand: bgFillBrand2,
    bgFillBrandHovered: pipeModifiers(modifiers.alpha({
      light: 0.88,
      dark: 0.88
    }), modifiers.solidify)(bgFillBrand2),
    bgFillBrandPressed: pipeModifiers(modifiers.alpha({
      light: 0.8,
      dark: 0.8
    }), modifiers.solidify)(bgFillBrand2),
    bgFillBrandSelected: pipeModifiers(modifiers.alpha({
      light: 0.84,
      dark: 0.84
    }), modifiers.solidify)(bgFillBrand2),
    bgFillBrandDisabled: pipeModifiers(modifiers.alpha({
      light: 0.64,
      dark: 0.64
    }), modifiers.solidify)(bgFillBrand2),
    // text brand
    textBrand: textBrand2,
    textBrandHovered: pipeModifiers(modifiers.alpha({
      light: 0.92,
      dark: 0.92
    }), modifiers.solidify)(textBrand2),
    textBrandPressed: pipeModifiers(modifiers.alpha({
      light: 0.8,
      dark: 0.8
    }), modifiers.solidify)(textBrand2),
    textBrandSelected: pipeModifiers(modifiers.alpha({
      light: 0.88,
      dark: 0.88
    }), modifiers.solidify)(textBrand2),
    textBrandDisabled: pipeModifiers(modifiers.alpha({
      light: 0.64,
      dark: 0.64
    }), modifiers.solidify)(textBrand2),
    // surface brand
    bgSurfaceBrand: bgSurfaceBrand2,
    bgSurfaceBrandHovered: pipeModifiers(modifiers.alpha({
      light: 0.16,
      dark: 0.24
    }), modifiers.elevateOnDarkMode, modifiers.solidify)(brandColor),
    bgSurfaceBrandPressed: pipeModifiers(modifiers.alpha({
      light: 0.24,
      dark: 0.32
    }), modifiers.elevateOnDarkMode, modifiers.solidify)(brandColor),
    bgSurfaceBrandSelected: pipeModifiers(modifiers.alpha({
      light: 0.12,
      dark: 0.2
    }), modifiers.elevateOnDarkMode, modifiers.solidify)(brandColor),
    bgSurfaceBrandDisabled: pipeModifiers(modifiers.alpha({
      light: 0.04,
      dark: 0.12
    }), modifiers.elevateOnDarkMode, modifiers.solidify)(brandColor),
    // text on brand
    textOnBgFillBrand: textOnBgFillBrand2,
    textOnBgFillBrandHovered: textOnBgFillBrand2,
    textOnBgFillBrandPressed: textOnBgFillBrand2,
    textOnBgFillBrandSelected: textOnBgFillBrand2,
    textOnBgFillBrandDisabled: pipeModifiers(modifiers.alpha({
      light: 0.4,
      dark: 0.4
    }), modifiers.toHex)(textOnBgFillBrand2),
    // other
    borderSelected: bgFillBrand2
  };
  return varMap;
};
const generateThemeOverrideCss = ({
  brandColor
}) => createThemedCssVarDefinitions(generateThemeOverride({
  brandColor
}), {
  kebabCase: true,
  prefix: "cb-color",
  selector: ":root"
});
export {
  color,
  dimension,
  generateThemeOverride,
  generateThemeOverrideCss,
  readThemedValue,
  shadow
};
//# sourceMappingURL=index.js.map
